import { render, staticRenderFns } from "./betassist.vue?vue&type=template&id=f9875f4c&"
import script from "./betassist.vue?vue&type=script&lang=js&"
export * from "./betassist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports